import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'normalizeEventName',
  standalone: true
})
export class NormalizeEventNamePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return String(value ?? '')
      .trim()
      .replace(/\s+/g, ' ')
  }
}
